/** Optional rate string (e.g. GraphQL Decimal) → number, or `undefined` if empty/invalid (including whitespace-only). */
export function parseRate(
  value: string | null | undefined,
): number | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const trimmed = value.trim();
  if (trimmed === '') {
    return undefined;
  }
  const parsed = Number(trimmed);
  if (Number.isNaN(parsed)) {
    return undefined;
  }
  return parsed;
}
